import { Grid } from '@material-ui/core';
import { ShortBody } from 'components/Typography';
import { AssuranceIcon } from 'images';
import React from 'react';
import { AlignedGrid, SizedGrid } from 'components/AccordionSinistre/styles';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'helpers/intl';
import messages from 'components/AccordionSinistre/messages';

const EmptyJournalSinistre = (props: { intl: IntlShape }) => {
  return (
    <SizedGrid
      justify="center"
      alignContent="center"
      direction="column"
      container
    >
      <AlignedGrid item>
        <img alt="" src={AssuranceIcon['EmptyJournalSinitre']} />
      </AlignedGrid>
      <Grid item>
        <ShortBody color="#9797AF" weight="400">
          {translate(messages.aucunContenu, props)}
        </ShortBody>
      </Grid>
    </SizedGrid>
  );
};

export default injectIntl(EmptyJournalSinistre);
